/**
 * Prevents Angular change detection from
 * running with certain Web Component callbacks
 */
const zoneWindow = window as Window & {
  __Zone_disable_customElements?: boolean;
};

zoneWindow.__Zone_disable_customElements = true;
